import ethLogo from 'libs/tokens/img/eth.svg';
import usdcLogo from 'libs/tokens/img/usdc.svg';
import wethLogo from 'libs/tokens/img/weth.svg';
// import xvsLogo from 'libs/tokens/img/lela.svg';
import lelaLogo from 'libs/tokens/img/lela.png'
import phronLogo from 'libs/tokens/img/phron.png'
import type { Token } from 'types';

const ethToken: Token = {
  address: '0x0000000000000000000000000000000000000000',
  decimals: 18,
  symbol: 'PHR',
  asset: phronLogo,
  isNative: true,
};

export const tokens: Token[] = [
  ethToken,
  {
    symbol: "WPHR",
    decimals: 18,
    address: "0x486B0cbF094e4DD99FD32B35EC92406d0D48c038",
    asset: phronLogo
  }, {
    symbol: "WETH",
    decimals: 18,
    address: "0x24aDCd3805DD847e70ad7A7a546a424d2400c087",
    asset: wethLogo,
  },
  {
    symbol: "LELA",
    decimals: 18,
    address: "0xd8BF3B072A6D3f83f8D48b085675036766A1dd2F",
    asset: lelaLogo,
  },
  {
    symbol: "USDC",
    decimals: 6,
    address: "0x8665057Fec27940435f23aE8E3cD60bFc25362A9",
    asset: usdcLogo
  }
];
